import { css } from '@emotion/react'

import { typo } from '~/@common/styles'
import Button from '~/@common/ui/(Button)/Button/Button'

type Props = {
  errorMessage: string
  onLogout: () => void
}

export const InitialDataLoadFailure = ({ errorMessage, onLogout }: Props) => {
  return (
    <div css={wrapperCss}>
      <div className="inner">
        <h1 className="title">일시적인 오류가 발생했어요</h1>
        <p className="description">
          데이터를 불러오는 데 실패했어요.
          <br />
          로그아웃 후 다시 로그인해주세요.
        </p>
        <Button theme="primary" minWidth={200} onClick={onLogout}>
          로그아웃하고 다시 로그인
        </Button>
        <div className="debug-info">
          <p className="debug-line">오류: {errorMessage}</p>
        </div>
      </div>
    </div>
  )
}

const wrapperCss = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 24px;

  .inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: 100%;
    max-width: 360px;
    text-align: center;
  }

  .title {
    ${typo.body01}
    color: var(--Colors-Gray-900);
    font-weight: 700;
  }

  .description {
    ${typo.body02}
    color: var(--Colors-Gray-700);
  }

  .debug-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
    padding: 12px;
    border-radius: var(--Radius-200);
    background: var(--Colors-Gray-100);
  }

  .debug-line {
    ${typo.caption01}
    color: var(--Colors-Gray-600);
    text-align: left;
  }
`
